import { useQuery } from '@tanstack/react-query';
import { getMerchantReadiness } from '../api/endpoints/merchant-readiness';
import { ErrorBanner } from './ErrorBanner';

const PROVIDERS = [{ id: 'yappy', name: 'Yappy' }, { id: 'paguelofacil', name: 'PagueloFacil' }] as const;

export function MerchantReadiness() {
  return <section className="section" aria-label="Pagos en línea">
    <h2 className="section-label">Pagos en línea</h2>
    <p className="row-sub">El estado corresponde a la cuenta de tu negocio. Para cobrar en línea necesitas completar la configuración con tu proveedor.</p>
    <div className="form-grid cols-2">{PROVIDERS.map(provider => <ProviderReadiness key={provider.id} provider={provider} />)}</div>
  </section>;
}

function ProviderReadiness({ provider }: { provider: typeof PROVIDERS[number] }) {
  const query = useQuery({ queryKey: ['merchant-readiness', provider.id], queryFn: () => getMerchantReadiness(provider.id) });
  const data = query.isError ? undefined : query.data;
  const status = !data?.environment ? 'Sin configurar' : data.environment === 'test' ? 'Pruebas' : 'Pagos reales';
  return <section className="card" aria-label={provider.name}>
    <h3 className="row-title">{provider.name}</h3>
    {query.isLoading ? <p className="row-sub">Verificando…</p> : null}
    {query.isError ? <><ErrorBanner message="No pudimos verificar este proveedor." /><button type="button" className="btn small secondary" onClick={() => void query.refetch()} disabled={query.isFetching}>Reintentar</button></> : null}
    {data ? <>
      <p className="status" data-tone={data.environment === 'live' && data.checkout ? 'good' : 'hold'}>{status}</p>
      <p className="row-sub">Cobros: {data.checkout ? 'disponibles' : 'no disponibles'}</p>
      <p className="row-sub">Pago anticipado: {data.prepay ? 'disponible' : 'no disponible'}</p>
      <p className="row-sub">Devoluciones: {data.refunds ? 'disponibles' : 'no disponibles'}</p>
      {data.environment === 'test' ? <p className="row-sub">Solo pruebas. No confirma que puedas recibir pagos reales.</p> : null}
    </> : null}
  </section>;
}
